import RadarChart from './src/radarChart';
import { withInstall } from '../_util/type';
export default withInstall(RadarChart);
